import {store} from '../app/store';
import {setSignupToken} from '../features/app/appSlice';
import {
  setActiveSub,
  setBearerToken,
  setCurrentSubDetails,
  setRefreshToken,
} from '../features/user/userSlice';
import {currentEnv, SignupTabs} from '../Utility/constants';
import {axiosInstance} from './axios/AxiosInstance';

export const createAndSub = (subscriptionCode, formData, activeTab, setErrorMsg, navigate) => {
  let subscriptionURL = '';
  let postData = new FormData();
  if (SignupTabs[activeTab] === 'key') {
    subscriptionURL = `/auth/subscribe/${SignupTabs[activeTab]}?Key=${formData?.key}`;
  } else if (SignupTabs[activeTab] === 'paylux') {
    subscriptionURL = `/auth/subscribe/${SignupTabs[activeTab]}?SubscriptionCode=${subscriptionCode}`;
    postData.append('FirstName', formData?.firstname);
    postData.append('LastName', formData?.lastname);
    postData.append('Address', formData?.address1);
    postData.append('Address2', formData?.address2);
    postData.append('Country', formData?.country);
    postData.append('City', formData?.city);
    postData.append('PostalCode', formData?.zip);
    postData.append('State', formData?.state);
    postData.append('FirstName', formData?.name);
    postData.append('CcNumber', formData?.cc);
    postData.append('Expiry', formData?.expiryMM + formData?.expiryYY);
    postData.append('Cvv', formData?.cvv);
  } else {
    subscriptionURL = `/auth/subscribe/${SignupTabs[activeTab]}?SubscriptionCode=${subscriptionCode}`;
  }

  axiosInstance
    .post(
      `/auth/create?Username=${encodeURIComponent(formData?.email)}&Password=${encodeURIComponent(formData?.password)}&Product=pilot`,
      {},
    )
    .then(res => {
      //console.log(res.data);
      store.dispatch(setSignupToken(res.data?.Token));
      axiosInstance
        .post(subscriptionURL, SignupTabs[activeTab] === 'paylux' ? postData : null, {
          headers: {
            Authorization: 'Bearer ' + res.data?.Token,
          },
        })
        .then(res => {
          console.log('authenticated with pilot ---- set jwt token here');
          window?.localStorage?.setItem('refreshToken', res?.data?.Refresh);
          window?.localStorage?.setItem('bearerToken', res?.data?.Token);
          store.dispatch(setRefreshToken(res?.data?.Refresh));
          store.dispatch(setBearerToken(res?.data?.Token));
          store.dispatch(setActiveSub(true));
          console.log('subscription', res?.data?.Subscription);
          store.dispatch(setCurrentSubDetails(res?.data?.Subscription));
          navigate('/subexpired');
          //redirect('/toplist');
        })
        .catch(err => {
          console.log('Error in subscribing', err);
          navigate('/subexpired');
        });
    })
    .catch(err => {
      console.log(`${currentEnv}/auth/subscribe/${SignupTabs[activeTab]}`);
      setErrorMsg(err.response?.data?.Message);
    });
};
